var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('toolbar',[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/service-contracts/contracts-list"}},[_c('i',{staticClass:"fa fa-caret-left fa-2x"}),_c('h2',[_vm._v("Service Contracts")])]),_c('div',{staticClass:"controls"},[_vm._t("toolbar-slot"),_c('nav-tabs',{attrs:{"tabs":_vm.tabs}})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }